module.exports = __webpack_public_path__ + "static/media/null_states_notifications_gray_wash.50f64a7f.svg";